import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import SummaryCards from "./SummaryCards";
import TopFarmers from "./TopFarmers";
import DailyTrendChart from "./DailyTrendChart";

export default function RecordsSummaryPage() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminCookie =
      Cookies.get("sessionidadmin");

    if (!adminCookie) {
      setLoading(false);
      return;
    }

    fetch(
      "https://api.terraweb.africa/getDailyRecords",
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
        },
        body: JSON.stringify({
          adminid: adminCookie,
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setRecords(data);
        }

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const now = new Date();

  const currentMonthRecords =
    records.filter((record) => {
      const d = new Date(
        record.daterecorded
      );

      return (
        d.getMonth() ===
          now.getMonth() &&
        d.getFullYear() ===
          now.getFullYear()
      );
    });


    const currentYearRecords =
  records.filter((record) => {
    const d = new Date(
      record.daterecorded
    );

    return (
      d.getFullYear() ===
      now.getFullYear()
    );
  });

const yearlyEntries =
  currentYearRecords.length;

const yearlyWeight =
  currentYearRecords.reduce(
    (sum, record) =>
      sum +
      Number(record.weight || 0),
    0
  );

const yearlyApproved =
  currentYearRecords.filter(
    (record) =>
      record.approved_status ===
      "approved"
  ).length;

const yearlyPending =
  currentYearRecords.filter(
    (record) =>
      record.approved_status !==
      "approved"
  ).length;

  const allTimeEntries =
  records.length;

const allTimeWeight =
  records.reduce(
    (sum, record) =>
      sum +
      Number(record.weight || 0),
    0
  );

const allTimeApproved =
  records.filter(
    (record) =>
      record.approved_status ===
      "approved"
  ).length;

const allTimePending =
  records.filter(
    (record) =>
      record.approved_status !==
      "approved"
  ).length;

  const previousMonthRecords =
    records.filter((record) => {
      const d = new Date(
        record.daterecorded
      );

      const prevMonth =
        now.getMonth() === 0
          ? 11
          : now.getMonth() - 1;

      const prevYear =
        now.getMonth() === 0
          ? now.getFullYear() - 1
          : now.getFullYear();

      return (
        d.getMonth() === prevMonth &&
        d.getFullYear() === prevYear
      );
    });

  const monthlyEntries =
    currentMonthRecords.length;

  const monthlyWeight =
    currentMonthRecords.reduce(
      (sum, record) =>
        sum +
        Number(record.weight || 0),
      0
    );

  const approvedCount =
    currentMonthRecords.filter(
      (record) =>
        record.approved_status ===
        "approved"
    ).length;

  const pendingCount =
    currentMonthRecords.filter(
      (record) =>
        record.approved_status !==
        "approved"
    ).length;

  const approvalRate =
    monthlyEntries > 0
      ? (approvedCount /
          monthlyEntries) *
        100
      : 0;

  const previousWeight =
    previousMonthRecords.reduce(
      (sum, record) =>
        sum +
        Number(record.weight || 0),
      0
    );

  const growthPercentage =
    previousWeight > 0
      ? (
          ((monthlyWeight -
            previousWeight) /
            previousWeight) *
          100
        )
      : 0;

  const farmerMap = {};

  currentMonthRecords.forEach(
    (record) => {
      if (
        !farmerMap[
          record.fullname
        ]
      ) {
        farmerMap[
          record.fullname
        ] = 0;
      }

      farmerMap[
        record.fullname
      ] += Number(
        record.weight || 0
      );
    }
  );

  const topFarmers =
    Object.entries(
      farmerMap
    )
      .map(
        ([fullname, weight]) => ({
          fullname,
          weight,
        })
      )
      .sort(
        (a, b) =>
          b.weight - a.weight
      )
      .slice(0, 10);

  if (loading) {
    return (
      <div className="pa4">
        Loading...
      </div>
    );
  }

  return (
    <div className="pa3 mt5">

      <h1 className="f2 mb4">
        Records Summary
      </h1>

      <SummaryCards
        monthlyEntries={
          monthlyEntries
        }
        monthlyWeight={
          monthlyWeight
        }
        approvedCount={
          approvedCount
        }
        pendingCount={
          pendingCount
        }
        approvalRate={
          approvalRate
        }
        growthPercentage={
          growthPercentage
        }
      />
{/* YEARLY SUMMARY */}
<div className="mt4">
  <h2 className="f3 mb3">
    Yearly Summary
  </h2>

  <div className="flex flex-wrap">

    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">Yearly Records</div>
        <div className="f2 fw6">{yearlyEntries}</div>
      </article>
    </div>

    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">Yearly Weight</div>
        <div className="f2 fw6">
          {yearlyWeight.toFixed(2)}
        </div>
      </article>
    </div>

    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">Approved</div>
        <div className="f2 fw6 green">
          {yearlyApproved}
        </div>
      </article>
    </div>

    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">Pending</div>
        <div className="f2 fw6 orange">
          {yearlyPending}
        </div>
      </article>
    </div>

  </div>
</div>

{/* ALL TIME SUMMARY */}
<div className="mt4">
  <h2 className="f3 mb3">
    All-Time Summary
  </h2>

  <div className="flex flex-wrap">

    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">Total Records</div>
        <div className="f2 fw6">
          {allTimeEntries}
        </div>
      </article>
    </div>

    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">Total Weight</div>
        <div className="f2 fw6">
          {allTimeWeight.toFixed(2)}
        </div>
      </article>
    </div>

    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">Approved</div>
        <div className="f2 fw6 green">
          {allTimeApproved}
        </div>
      </article>
    </div>

    <div className="w-100 w-50-m w-25-l pa2">
      <article className="bg-white shadow-4 br3 pa3 tc">
        <div className="gray">Pending</div>
        <div className="f2 fw6 orange">
          {allTimePending}
        </div>
      </article>
    </div>

  </div>
</div>

    <TopFarmers
  farmers={topFarmers}
/>

<DailyTrendChart
  records={currentMonthRecords}
/>

    </div>
  );
}